function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuWishlist = function SvgMenuWishlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M904.7 170.6C852.5 116.7 783 87 709.1 87c-45.1 0-90 11.4-129.6 33.2-24.8 13.6-47.7 31.1-67.5 51.9-19.8-20.7-42.7-38.2-67.5-51.9C404.9 98.4 360.1 87 314.9 87c-73.9 0-143.4 29.8-195.6 83.7s-81 125.6-81 202c0 64.6 17.1 130.9 51 197.2 29 56.9 69.7 112.7 120.9 166.1 86.5 90.1 200.5 168.3 290.6 199.2 3.6 1.3 7.5 1.9 11.3 1.9s7.7-.6 11.3-1.9C613.6 904.3 727.7 826.1 814 736c51.2-53.4 91.8-109.3 120.9-166.1 33.9-66.4 51-132.7 51-197.2-.1-76.3-29-148.2-81.2-202.1",
    style: {
      fill: "#666"
    }
  }));
};
export default SvgMenuWishlist;